/**
 *  jquery.youtubeplaylist.js
 *  dan@allbutlost.com
 *
 *  Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 */

String.prototype.startsWith = function (str) {
    return (this.indexOf(str) === 0);
};

jQuery.fn.ytplaylist = function (options) {

    // default settings
    var options = jQuery.extend({
        holderId: 'ytvideo',
        playerHeight: 300,
        playerWidth: 450,
        addThumbs: false,
        thumbSize: 'small',
        showInline: false,
        autoPlay: false,
        showRelated: false,
        allowFullScreen: false
    }, options);

    return this.each(function () {

        var $el = $(this);

        var autoPlay = "";
        var showRelated = "&rel=0";
        var fullScreen = "";
        if (options.autoPlay) autoPlay = "&autoplay=1";
        if (options.showRelated) showRelated = "&rel=1";
        if (options.allowFullScreen) fullScreen = "&fs=1";

        //throw a youtube player in
        function playOld(id) {
            var html = '';

            html += '<object height="' + options.playerHeight + '" width="' + options.playerWidth + '">';
            html += '<param name="movie" value="https://www.youtube.com/v/' + id + autoPlay + showRelated + fullScreen + '"> </param>';
            html += '<param name="wmode" value="transparent"> </param>';
            if (options.allowFullScreen) {
                html += '<param name="allowfullscreen" value="true"> </param>';
            }
            html += '<embed src="https://www.youtube.com/v/' + id + autoPlay + showRelated + fullScreen + '"';
            if (options.allowFullScreen) {
                html += ' allowfullscreen="true" ';
            }
            html += 'type="application/x-shockwave-flash" wmode="transparent"  height="' + options.playerHeight + '" width="' + options.playerWidth + '"></embed>';
            html += '</object>';

            return html;
        }

        //edit this to get iframe embed code working properly-michiko
        function playNew(id, type) {
            var html = '';
            if (type == "youtube") {
                html += '<iframe width="' + options.playerWidth + '" height="' + options.playerHeight + '"';
                html += ' src="https://www.youtube.com/embed/' + id + '?wmode=opaque?fs=1' + autoPlay + showRelated + '" frameborder="0"';
                html += ' allowfullscreen></iframe>';
            } else if (type == "vimeo") {
                html += '<iframe width="' + options.playerWidth + '" height="' + options.playerHeight + '"';
                html += ' src="//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=cc0000';
                html += '  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
            }
            return html;
        }

        //grab a youtube id from a (clean, no querystring) url (thanks to http://jquery-howto.blogspot.com/2009/05/jyoutube-jquery-youtube-thumbnail.html)
        function youtubeid(url) {
            var ytid = url.match("[\\?&]v=([^&#]*)");
            ytid = ytid[1];
            return ytid;
        }

        $el.children('li').each(function () {
            $(this).find('a').each(function () {
                var thisHref = $(this).attr('href');

                //old-style youtube links
                if (thisHref.startsWith('http://www.youtube.com') || thisHref.startsWith('https://www.youtube.com')) {
                    $(this).addClass('yt-vid');
                    $(this).data('yt-id', youtubeid(thisHref));
                    $(this).data('yt-type', 'youtube');
                }
                //new style youtu.be links
                else if (thisHref.startsWith('http://youtu.be') || thisHref.startsWith('https://youtu.be')) {
                    $(this).addClass('yt-vid');
                    var id = thisHref.substr(thisHref.lastIndexOf("/") + 1);
                    $(this).data('yt-id', id);
                    $(this).data('yt-type', 'youtube');
                }
                //vimeo link
                else if (thisHref.startsWith('http://player.vimeo.com') || thisHref.startsWith('https://player.vimeo.com/')) {
                    $(this).addClass('yt-vid vimeo-vid');
                    var id = thisHref.substr(thisHref.lastIndexOf("/") + 1);
                    $(this).data('yt-id', id);
                    $(this).data('yt-type', 'vimeo');
                }
                else {
                    //must be an image link (naive)
                    $(this).addClass('img-link');
                }

            });
        });


        //load video on request
        $el.children("li").children("a.yt-vid").click(function () {
            var videoID = $(this).data("yt-id");
            var videoType = $(this).data('yt-type');
            if (options.showInline) {
                $("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo").html(playNew(videoID, videoType));
            }
            else {
                $("#" + options.holderId + "").html(playNew(videoID, videoType));
                $(this).parent().parent("ul").find("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo");
            }
            return false;
        });

        $el.find("a.img-link").click(function () {
            var $img = $('<img/>');
            $img.attr({ src: $(this).attr('href') })
                .css({
                    display: 'none',
                    position: 'absolute',
                    left: '0px',
                    top: '50%'
                });

            if (options.showInline) {
                $("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo").html($img);
            }
            else {
                $("#" + options.holderId + "").html($img);
                $(this).closest("ul").find("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo");
            }

            //wait for image to load (webkit!), then set width or height
            //based on dimensions of the image
            setTimeout(function () {
                if ($img.height() < $img.width()) {
                    $img.width(options.playerWidth).css('margin-top', parseInt($img.height() / -2, 10)).css({
                        height: 'auto'
                    });
                }
                else {
                    $img.css({
                        height: options.playerHeight,
                        width: 'auto',
                        top: '0px',
                        position: 'relative'
                    });
                }

                $img.fadeIn();

            }, 100);


            return false;
        });


        // do we want thumbs with that?
        if (options.addThumbs) {

            $el.children().each(function (i) {

                //replace first link
                var $link = $(this).find('a:first');
                var replacedText = $(this).text();
                var thumbUrl;
                if ($link.hasClass('vimeo-vid')) {
                    var vimeoVideoID = $link.data("yt-id");
                    $.getJSON('http://www.vimeo.com/api/v2/video/' + vimeoVideoID + '.json?callback=?', { format: "json" }, function (data) {
                        thumbUrl = data[0].thumbnail_large;
                        var thumbHtml = "<img src='" + thumbUrl + "' alt='" + replacedText + "' /><span class='play'></span>";
                        $link.empty().html(thumbHtml + replacedText).attr("title", replacedText);
                    });
                }
                else if ($link.hasClass('yt-vid')) {
                    if (options.thumbSize == 'small') {
                        thumbUrl = "https://img.youtube.com/vi/" + $link.data("yt-id") + "/2.jpg";
                    }
                    else if (options.thumbSize == 'large') {
                        thumbUrl = "https://img.youtube.com/vi/" + $link.data("yt-id") + "/0.jpg";
                    } else {
                        thumbUrl = "https://img.youtube.com/vi/" + $link.data("yt-id") + "/mqdefault.jpg";
                    }
                    var thumbHtml = "<img src='" + thumbUrl + "' alt='" + replacedText + "' /><span class='play'></span>";

                    $link.empty().html(thumbHtml + replacedText).attr("title", replacedText);

                }
                else {
                    //is an image link
                    var $img = $('<img/>').attr('src', $link.attr('href'));
                    $link.empty().html($img).attr("title", replacedText);
                }

            });

        }

        //don't load inital video
        var firstVid = $el.children("li:first-child").addClass("currentvideo").children("a").click();

    });

};

/**
 *  jquery.youtubeplaylist.js
 *  dan@allbutlost.com
 *
 *  Licensed under the MIT license: http://www.opensource.org/licenses/mit-license.php
 */

String.prototype.startsWith = function (str) {
    return (this.indexOf(str) === 0);
};


jQuery.fn.ytplaylist = function (options) {

    // default settings
    var options = jQuery.extend({
        holderId: 'ytvideo',
        playerHeight: 300,
        playerWidth: 450,
        addThumbs: false,
        thumbSize: 'small',
        showInline: false,
        autoPlay: false,
        showRelated: false,
        allowFullScreen: false
    }, options);

    return this.each(function () {

        var $el = $(this);

        var autoPlay = "";
        var showRelated = "&rel=0";
        var fullScreen = "";
        if (options.autoPlay) autoPlay = "&autoplay=1";
        if (options.showRelated) showRelated = "&rel=1";
        if (options.allowFullScreen) fullScreen = "&fs=1";

        //throw a youtube player in
        function playOld(id) {
            var html = '';

            html += '<object height="' + options.playerHeight + '" width="' + options.playerWidth + '">';
            html += '<param name="movie" value="https://www.youtube.com/v/' + id + autoPlay + showRelated + fullScreen + '"> </param>';
            html += '<param name="wmode" value="transparent"> </param>';
            if (options.allowFullScreen) {
                html += '<param name="allowfullscreen" value="true"> </param>';
            }
            html += '<embed src="https://www.youtube.com/v/' + id + autoPlay + showRelated + fullScreen + '"';
            if (options.allowFullScreen) {
                html += ' allowfullscreen="true" ';
            }
            html += 'type="application/x-shockwave-flash" wmode="transparent"  height="' + options.playerHeight + '" width="' + options.playerWidth + '"></embed>';
            html += '</object>';

            return html;
        }

        //edit this to get iframe embed code working properly-michiko
        function playNew(id, type) {
            var html = '';
            if (type == "youtube") {
                html += '<iframe width="' + options.playerWidth + '" height="' + options.playerHeight + '"';
                html += ' src="https://www.youtube.com/embed/' + id + '?wmode=opaque?fs=1' + autoPlay + showRelated + '" frameborder="0"';
                html += ' allowfullscreen></iframe>';
            } else if (type == "vimeo") {
                html += '<iframe width="' + options.playerWidth + '" height="' + options.playerHeight + '"';
                html += ' src="//player.vimeo.com/video/' + id + '?title=0&amp;byline=0&amp;portrait=0&amp;color=cc0000';
                html += '  frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>';
            }
            return html;
        }

        //grab a youtube id from a (clean, no querystring) url (thanks to http://jquery-howto.blogspot.com/2009/05/jyoutube-jquery-youtube-thumbnail.html)
        function youtubeid(url) {
            var ytid = url.match("[\\?&]v=([^&#]*)");
            ytid = ytid[1];
            return ytid;
        }

        $el.children('li').each(function () {
            $(this).find('a').each(function () {
                var thisHref = $(this).attr('href');

                //old-style youtube links
                if (thisHref.startsWith('http://www.youtube.com') || thisHref.startsWith('https://www.youtube.com')) {
                    $(this).addClass('yt-vid');
                    $(this).data('yt-id', youtubeid(thisHref));
                    $(this).data('yt-type', 'youtube');
                }
                //new style youtu.be links
                else if (thisHref.startsWith('http://youtu.be') || thisHref.startsWith('https://youtu.be')) {
                    $(this).addClass('yt-vid');
                    var id = thisHref.substr(thisHref.lastIndexOf("/") + 1);
                    $(this).data('yt-id', id);
                    $(this).data('yt-type', 'youtube');
                }
                //vimeo link
                else if (thisHref.startsWith('http://player.vimeo.com') || thisHref.startsWith('https://player.vimeo.com/')) {
                    $(this).addClass('yt-vid vimeo-vid');
                    var id = thisHref.substr(thisHref.lastIndexOf("/") + 1);
                    $(this).data('yt-id', id);
                    $(this).data('yt-type', 'vimeo');
                }
                else {
                    //must be an image link (naive)
                    $(this).addClass('img-link');
                }

            });
        });


        //load video on request
        $el.children("li").children("a.yt-vid").click(function () {
            var videoID = $(this).data("yt-id");
            var videoType = $(this).data('yt-type');
            if (options.showInline) {
                $("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo").html(playNew(videoID, videoType));
            }
            else {
                $("#" + options.holderId + "").html(playNew(videoID, videoType));
                $(this).parent().parent("ul").find("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo");
            }
            return false;
        });

        $el.find("a.img-link").click(function () {
            var $img = $('<img/>');
            $img.attr({ src: $(this).attr('href') })
                .css({
                    display: 'none',
                    position: 'absolute',
                    left: '0px',
                    top: '50%'
                });

            if (options.showInline) {
                $("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo").html($img);
            }
            else {
                $("#" + options.holderId + "").html($img);
                $(this).closest("ul").find("li.currentvideo").removeClass("currentvideo");
                $(this).parent("li").addClass("currentvideo");
            }

            //wait for image to load (webkit!), then set width or height
            //based on dimensions of the image
            setTimeout(function () {
                if ($img.height() < $img.width()) {
                    $img.width(options.playerWidth).css('margin-top', parseInt($img.height() / -2, 10)).css({
                        height: 'auto'
                    });
                }
                else {
                    $img.css({
                        height: options.playerHeight,
                        width: 'auto',
                        top: '0px',
                        position: 'relative'
                    });
                }

                $img.fadeIn();

            }, 100);


            return false;
        });


        // do we want thumbs with that?
        if (options.addThumbs) {

            $el.children().each(function (i) {

                //replace first link
                var $link = $(this).find('a:first');
                var replacedText = $(this).text();
                var thumbUrl;
                if ($link.hasClass('vimeo-vid')) {
                    var vimeoVideoID = $link.data("yt-id");
                    $.getJSON('http://www.vimeo.com/api/v2/video/' + vimeoVideoID + '.json?callback=?', { format: "json" }, function (data) {
                        thumbUrl = data[0].thumbnail_large;
                        var thumbHtml = "<img src='" + thumbUrl + "' alt='" + replacedText + "' /><span class='play'></span>";
                        $link.empty().html(thumbHtml + replacedText).attr("title", replacedText);
                    });
                }
                else if ($link.hasClass('yt-vid')) {
                    if (options.thumbSize == 'small') {
                        thumbUrl = "https://img.youtube.com/vi/" + $link.data("yt-id") + "/2.jpg";
                    }
                    else if (options.thumbSize == 'large') {
                        thumbUrl = "https://img.youtube.com/vi/" + $link.data("yt-id") + "/0.jpg";
                    } else {
                        thumbUrl = "https://img.youtube.com/vi/" + $link.data("yt-id") + "/mqdefault.jpg";
                    }
                    var thumbHtml = "<img src='" + thumbUrl + "' alt='" + replacedText + "' /><span class='play'></span>";

                    $link.empty().html(thumbHtml + replacedText).attr("title", replacedText);

                }
                else {
                    //is an image link
                    var $img = $('<img/>').attr('src', $link.attr('href'));
                    $link.empty().html($img).attr("title", replacedText);
                }

            });

        }

        //don't load inital video
        var firstVid = $el.children("li:first-child").addClass("currentvideo").children("a").click();

    });
};
